import React from "react";
import ImageWithFallback from "../ImageWithFallback";

export default function Avatar({ width, height, avatarUrl, className, fallback }) {
  return (
    <div className={`upload-profile d-inline-block ${className}`}>
      <div
        className="upload-profile__container"
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        {avatarUrl ? (
          <ImageWithFallback
                src={avatarUrl}
                alt={"avatar"}
                fallback={fallback ? fallback : '/images/profile.png'}
                className="img"
              />
        ) : (
          <img className="img" alt="" src="/images/profile.png" />
        )}
      </div>
    </div>
  );
}
